import {
  SET_MOBILE_SIDEBAR_STATE,
  SET_SIDENAV_STATE,
  SET_NOTIFICATIONS_SIDEBAR_STATE,
} from './layoutActions';

export const initialState = {
  sideNavExpanded: false,
  notificationsSidebarExpanded: false,
};

const layoutReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_MOBILE_SIDEBAR_STATE: {
      return {
        ...state,
        mobileSidebarExpanded: action.expanded,
      };
    }

    case SET_SIDENAV_STATE: {
      return {
        ...state,
        sideNavExpanded: action.expanded,
      };
    }

    case SET_NOTIFICATIONS_SIDEBAR_STATE: {
      return {
        ...state,
        notificationsSidebarExpanded: action.expanded,
      };
    }

    default:
      return state;
  }
};

export default layoutReducer;
